import { render, staticRenderFns } from "./ParallaxElement.vue?vue&type=template&id=bb2ea35c&"
import script from "./ParallaxElement.vue?vue&type=script&lang=js&"
export * from "./ParallaxElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports